import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.user.DOC}
  query SpaceAssignableUsers(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $quantity: Int
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          users(quantity: $quantity) {
            items {
              info {
                ...FragmentSpaceUserAccessUser
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.SpaceAssignableUsersQuery,
    ents.extra.space.User[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'users',
          graphql.transformers.OUT.select(
            'items',
            graphql.transformers.OUT.list(
              graphql.transformers.OUT.select(
                'info',
                fragments.user.TRANSFORMER,
              ),
              { onNullish: 'remove' },
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.SpaceAssignableUsersQuery,
  ents.extra.space.User[],
  graphql.schema.SpaceAssignableUsersQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
